import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <>
      {/*  <div className="bg-slate-600">
        <div className=" footer sm:footer-horizontal text-white p-8 py-10 max-w-screen-2xl mx-auto">
          <aside>
            <p className="text-lg font-black">MOUNTAIN MARATHON FESTIVAL</p>

            <p className="lg:max-w-3xl">
              Experience the ultimate mountain trail running challenge across
              three spectacular Indonesian locations.
            </p>

            <p className="lg:max-w-2xl">
              Join hundreds of athletes in conquering volcanic peaks, ancient
              forests, and sacred mountains.
            </p>
          </aside>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Gabung</h6>
            <Link to="/Sukarelawan" className="link link-hover">
              Sukarelawan
            </Link>
            <Link to="/Sponsor" className="link link-hover">
              Sponsor
            </Link>
          </nav>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Informasi</h6>
            <Link to="/KebijakanPrivasi" className="link link-hover">
              Kebijakan Privasi
            </Link>
            <Link to="/SyaratKetentuan" className="link link-hover">
              Syarat & Ketentuan
            </Link>
            <Link to="/TentangKami" className="link link-hover">
              Tentang Kami
            </Link>
          </nav>

          <nav className="mt-4">
            <h6 className="text-lg font-bold uppercase">Ikuti Kami</h6>
            <div className="flex flex-col items-start space-y-4">
              <a
                href="https://www.instagram.com/mountainmarathonfestival/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-white"
              >
                <FaInstagram className="text-xl mr-2" />
                <span>mountainmarathonfestival</span>
              </a>
            </div>
          </nav>
        </div>
      </div> */}

      <footer className="footer sm:footer-horizontal footer-center bg-slate-200 text-slate-400 p-4">
        <aside>
          <p>
            Copyright © {new Date().getFullYear()} - All rights reserved
            Mountain Marathon Festival
          </p>
        </aside>
      </footer>
    </>
  );
};
